import { Icon } from "@src/components/deprecated/Icon/Icon";
import { Text } from "@src/components/deprecated/Text/Text";
import { Stack } from "@src/components/ui-components/Stack/Stack";
import { GlobalFileData } from "@src/to-be-removed/LocalData/Files/GlobalFileData";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { FileDocumentData } from "../../../../../to-be-removed/LocalData/General/FileDocumentData";
import { FirebaseFile } from "../../../../../to-be-removed/LocalData/General/FirebaseFile";
import { FileTypeImageView } from "../../../../ui-components/FileTypeImageView/FileTypeImageView";
import DisplayedFileData from "../../../FilePopup/DisplayedFileData";
import { FilePopup } from "../../../FilePopup/FilePopup";
import { Popup } from "../../../Popup/Popup";

type Props = {
  files: (FirebaseFile | FileDocumentData | GlobalFileData)[];
};

export const DataTableFileDocumentsCell = (props: Props) => {
  const [, setLastUpdate] = useState(new Date());
  const [showFiles, setShowFiles] = useState(false);
  const [allFiles, setAllFiles] = useState<DisplayedFileData[]>(props.files.map((file) => new DisplayedFileData(file)));
  const files = allFiles.filter((file) => file.name || file.path);

  useEffect(() => {
    const newFiles = props.files.map((file) => new DisplayedFileData(file));
    const filesToLoad = newFiles.filter((file) => !file.isDataLoaded);
    if (filesToLoad.length > 0) {
      Promise.all(filesToLoad.map((file) => file.loadData())).finally(() => setLastUpdate(new Date()));
    } else {
      setAllFiles(newFiles);
    }
  }, [props.files]);

  if (files.length === 0)
    return (
      <Text size="sm" fontWeight={500}>
        {t("main.noFiles")}
      </Text>
    );

  const sortedFiles = files.filter((file) => !file.archived).sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Stack spacing={12} direction="column">
      <button
        style={{ display: "flex", alignItems: "center" }}
        onClick={(e) => {
          setShowFiles(!showFiles);
          e.preventDefault();
        }}
      >
        <Icon size={20} name={showFiles ? "keyboard_arrow_up" : "keyboard_arrow_down"} />
        <Text size="sm" fontWeight={500}>
          {t("main.amountOfFiles", { amount: sortedFiles.length })}
        </Text>
      </button>
      {showFiles && (
        <Stack spacing={12} direction="column">
          {sortedFiles.map((file) => {
            return (
              <div
                key={file.id}
                style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  Popup.present((id) => <FilePopup id={id} file={file} otherFiles={sortedFiles} />);
                }}
              >
                <FileTypeImageView height="24px" fileType={file.type} />
                <Text size="sm" fontWeight={500} style={{ wordBreak: "break-word" }}>
                  {file.name}
                </Text>
              </div>
            );
          })}
        </Stack>
      )}
    </Stack>
  );
};
